import React, { useState, useEffect } from "react";
import axios from "axios";
import styled from "styled-components";
import { useNavigate } from "react-router-dom";


const RegisterWithOTP = () => {
  const [step, setStep] = useState(1);
  const [phone, setPhone] = useState("");
  const [otp, setOtp] = useState("");
  const [sessionId, setSessionId] = useState("");
  const [fullName, setFullName] = useState("");
  const [address, setAddress] = useState("");
  const [password, setPassword] = useState("");
  const [resendTimer, setResendTimer] = useState(0);

  const navigate = useNavigate();

  // Timer countdown effect
  useEffect(() => {
    if (resendTimer > 0) {
      const timer = setInterval(() => {
        setResendTimer((prev) => prev - 1);
      }, 1000);
      return () => clearInterval(timer);
    }
  }, [resendTimer]);

  const sendOtp = async () => {
    try {
      const res = await axios.post(`https://bullion-backend-5pu3.onrender.com/api/auth/send-otp`, { phone });
      if (res.data.success) {
        setSessionId(res.data.sessionId);
        setStep(2);
        setResendTimer(30);
      } else {
        alert(res.data.message || "OTP send failed");
      }
    } catch (err) {
      alert("Error sending OTP");
    }
  };

  const resendOtp = async () => {
    try {
      const res = await axios.post(`https://bullion-backend-5pu3.onrender.com/api/auth/resend-otp`, { phone });
      if (res.data.success) {
        setSessionId(res.data.sessionId);
        setResendTimer(30);
        alert("OTP resent successfully");
      } else {
        alert(res.data.message || "Failed to resend OTP");
      }
    } catch (err) {
      alert("Error resending OTP");
    }
  };

  const verifyOtp = async () => {
    try {
      const res = await axios.post(`https://bullion-backend-5pu3.onrender.com/api/auth/verify-otp`, { sessionId, otp });
      if (res.data.success) {
        setStep(3);
      } else {
        alert(res.data.message || "OTP verification failed");
      }
    } catch (err) {
      alert("Error verifying OTP");
    }
  };

  const registerUser = async () => {
    try {
      const res = await axios.post(`https://bullion-backend-5pu3.onrender.com/api/auth/register-after-otp`, {
        fullName,
        address,
        phone,
        password,
      });

      if (res.data.success) {
        alert("Registration successful!");
        navigate("/login");
      } else {
        alert(res.data.message || "Something went wrong");
      }
    } catch (err) {
      console.error("Registration Error:", err.response?.data || err.message);
      alert("Error registering user");
    }
  };

  return (
    <PageWrapper>
              <Card>
        <BackButton onClick={() => navigate("/")}>← Back</BackButton>
        <Title>Register</Title>

      {step === 1 && (
        <>
        <StyledInput
            type="text"
            placeholder="Enter Phone Number"
            value={phone}
            onChange={(e) => setPhone(e.target.value)}
          />
          <StyledButton onClick={sendOtp}>Send OTP</StyledButton>
        </>
      )}

      {step === 2 && (
        <>
        <StyledInput
            type="text"
            placeholder="Enter OTP"
            value={otp}
            onChange={(e) => setOtp(e.target.value)}
          />
          <StyledButton onClick={verifyOtp}>Verify OTP</StyledButton>
          <ResendSection>
            <StyledButton onClick={resendOtp} disabled={resendTimer > 0}>
              {resendTimer > 0 ? `Resend OTP in ${resendTimer}s` : "Resend OTP"}
            </StyledButton>
          </ResendSection>
        </>
      )}

      {step === 3 && (
        <>
        <StyledInput
            type="text"
            placeholder="Your Name"
            value={fullName}
            onChange={(e) => setFullName(e.target.value)}
          />
        <StyledInput
            type="text"
            placeholder="Your Address"
            value={address}
            onChange={(e) => setAddress(e.target.value)}
          />
        <StyledInput
            type="password"
            placeholder="Create Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
          <StyledButton onClick={registerUser}>Register</StyledButton>
        </>
      )}
         </Card>
    </PageWrapper>
  );
};

export default RegisterWithOTP;

// Styled Components
const PageWrapper = styled.div`
  background-color: #000;
  color: #f5d76e;
  font-family: "Segoe UI", sans-serif;
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2rem;
`;

const Card = styled.div`
  background-color: #111;
  padding: 2.5rem 2rem 2rem;
  border-radius: 12px;
  max-width: 400px;
  width: 100%;
  position: relative;
  box-shadow: 0 0 12px rgba(255, 215, 0, 0.2);
`;

const Title = styled.h2`
  font-size: 1.5rem;
  text-align: center;
  margin-bottom: 1.5rem;
`;

const StyledInput = styled.input`
  width: 100%;
  padding: 0.7rem;
  margin-bottom: 1rem;
  border-radius: 8px;
  border: 1px solid #f5d76e;
  background: #1a1a1a;
  color: #f5d76e;
  font-size: 1rem;

  &:focus {
    outline: none;
    border-color: #ffcc00;
  }
`;

const StyledButton = styled.button`
  width: 100%;
  padding: 0.8rem;
  border: none;
  border-radius: 8px;
  background-color: #f5d76e;
  color: #000;
  font-weight: bold;
  font-size: 1rem;
  cursor: pointer;

  &:hover {
    background-color: #ffe58f;
  }
`;

const ErrorText = styled.p`
  margin-top: 1rem;
  text-align: center;
  color: #ff6b6b;
  font-size: 0.95rem;
`;

const BackButton = styled.button`
  position: absolute;
  top: 1rem;
  left: 1rem;
  background: transparent;
  border: 1px solid #937676;
  color: #f5d76e;
  font-size: 0.9rem;
  border-radius: 6px;
  padding: 0.4rem 0.8rem;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    background-color: #f5d76e;
    color: #000;
  }
`;
const BackBottomButton = styled(StyledButton)`
  background-color: transparent;
  color: #f5d76e;
  font-weight: normal;
  font-size: 0.95rem;
  margin-top: 1rem;
  border: 1px solid #f5d76e;

  &:hover {
    background-color: #f5d76e;
    color: #000;
  }
`;
const ResendSection = styled.div`
  margin-top: 10px;
  text-align: center;

  button {
    background-color: transparent;
    color: #007bff;
    font-weight: bold;
    text-decoration: underline;
    border: none;
    cursor: pointer;

    &:disabled {
      color: #aaa;
      text-decoration: none;
    }
  }
`;